import { Grid, IconButton } from "@material-ui/core";
import { Info } from "@material-ui/icons";
import styled, { css } from "styled-components";

const montserrat = (props) => props.theme.fonts.montserrat;
const opensans = (props) => props.theme.fonts.opensans;
const roboto = (props) => props.theme.fonts.roboto;

const black = (props) => props.theme.palette.black;
const grey = (props) => props.theme.palette.grey;
const primary = (props) => props.theme.palette.primary;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

export const OfxDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
`;

export const AuxSpan = styled.span`
  margin-top: 10px;
  color: ${grey};
  font-family: ${roboto};
  font-size: 12px;
`;

export const IndicatorStyled = styled.div`
  display: flex;
  flex-direction: column;

  b {
    font-size: 20px;
    font-weight: bolder;
    font-family: ${opensans};
  }

  span {
    font-family: ${montserrat};
    font-size: 14px;
  }
`;

export const StatusBar = styled.span`
  font-family: ${roboto};
  font-size: 14px;
  padding: 3px 8px;
  border-radius: 5px;
  color: white;
  background-color: ${(props) => props.color || "#000"};
  white-space: nowrap;
  place-self: flex-end;
  font-weight: bold;
`;

export const CustomDiv = styled.div`
  display: flex;
  align-items: center;
  ${(props) => (props.margin ? "margin-top: 15px;" : "")};

  span {
    margin-left: 5px;
  }
`;

export const IconBox = styled.div`
  color: ${(props) => props.color};
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: #00000025;
  margin-bottom: 30px;
  margin-bottom: 160px;
`;

export const ContainerRow = styled.div`
  position: relative;
  padding: 3px;
  overflow-x: hidden;

  &:not(:last-child) {
    margin-bottom: 30px;
  }
`;

export const ExtractContainter = styled.div`
  ${ContainerRow} {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    align-items: center;
  }
`;

export const CardBody = styled.div`
  padding: 10px 20px;

  width: 100%;
  max-width: 32%;
  min-height: 110px;

  background: #f9f9f9;
  box-shadow: 0px 4px 5px #00000025;

  border-radius: 10px;

  .Row {
    font-family: ${roboto};
    display: flex;
    justify-content: space-between;

    .Divisor {
      display: flex;
      flex-direction: column;
    }

    .Date {
      font-weight: bold;
      /* margin-bottom: 15px; */
      font-size: 18px;
      color: ${black};
    }

    .History {
      color: ${grey};

      .Title {
        font-weight: bold;
      }
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      &.NoMargin {
        margin: 0;
      }
    }

    &.NoMargin {
      margin: 0;
    }

    &.FlexEnd {
      justify-content: flex-end;
      margin-top: 15px;
    }
  }
`;

export const IconButtonStyled = styled(IconButton)`
  background-color: ${primary} !important;
  color: white !important;

  :hover {
    background-color: orange !important;
  }

  &.Mui-disabled {
    background-color: #eeeeee !important;
  }

  .MuiSvgIcon-root {
    font-size: 1.3rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.custom &&
    css`
      width: 100%;
      max-width: 32%;
      padding: 10px 20px;
    `}
`;

export const IgnoreButton = styled.span`
  margin-top: 15px;
  font-family: ${roboto};
  color: ${grey};
  transition: 0.3s;

  &:hover {
    color: ${black};
    cursor: pointer;
  }
`;

export const InfoButton = styled(Info)`
  font-family: ${roboto};
  color: orange;
  transition: 0.3s;

  &:hover {
    color: ${primary};
    cursor: pointer;
  }
`;

export const GridTitleSeparator = styled(Grid)`
  margin-bottom: 20px;
  span {
    font-family: ${montserrat};
    display: flex;
    font-size: 22px;
    text-align: center;
    justify-content: center;
  }
`;
